'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HttpGateway = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _response_sensor = require('./response_sensor');

var _aureliaFetchClient = require('aurelia-fetch-client');

var _http_client_factory = require('../util/http_client_factory');

var _rails_json_date_transformer = require('../util/rails_json_date_transformer');

var _rails_json_date_transformer2 = _interopRequireDefault(_rails_json_date_transformer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var HttpGateway = exports.HttpGateway = function () {
  function HttpGateway(httpClientFactory, telemetry) {
    _classCallCheck(this, HttpGateway);

    this.http = httpClientFactory;
    this.sensor = new _response_sensor.ResponseSensor();
    this.transformer = new _rails_json_date_transformer2.default();
    this.telemetry = telemetry;
  }

  _createClass(HttpGateway, [{
    key: 'get',
    value: function get(path) {
      var overrides = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return this.getWithClient(this.http.createClient(), path, overrides);
    }
  }, {
    key: 'authenticatedGet',
    value: function authenticatedGet(secretKey, path) {
      var overrides = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      return this.getWithClient(this.http.createAuthenticatedClient(secretKey), path, overrides);
    }
  }, {
    key: 'post',
    value: function post(path, data) {
      var overrides = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      return this.postWithClient(this.http.createClient(), path, data, overrides);
    }
  }, {
    key: 'authenticatedPost',
    value: function authenticatedPost(secretKey, path, data) {
      var overrides = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

      return this.postWithClient(this.http.createAuthenticatedClient(secretKey), path, data, overrides);
    }
  }, {
    key: 'put',
    value: function put(path, data) {
      var overrides = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      return this.putWithClient(this.http.createClient(), path, data, overrides);
    }
  }, {
    key: 'authenticatedPut',
    value: function authenticatedPut(secretKey, path, data) {
      var overrides = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

      return this.putWithClient(this.http.createAuthenticatedClient(secretKey), path, data, overrides);
    }
  }, {
    key: 'delete',
    value: function _delete(path) {
      var overrides = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return this.deleteWithClient(this.http.createClient(), path, overrides);
    }
  }, {
    key: 'authenticatedDelete',
    value: function authenticatedDelete(secretKey, path) {
      var overrides = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      return this.deleteWithClient(this.http.createAuthenticatedClient(secretKey), path, overrides);
    }
  }, {
    key: 'getWithClient',
    value: function getWithClient(client, path) {
      var overrides = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      return this.simpleRequestWithClient(client, _http_client_factory.HttpVerbs.GET, path, overrides);
    }
  }, {
    key: 'deleteWithClient',
    value: function deleteWithClient(client, path, overrides) {
      return this.simpleRequestWithClient(client, _http_client_factory.HttpVerbs.DELETE, path, overrides);
    }
  }, {
    key: 'postWithClient',
    value: function postWithClient(client, path, data) {
      var overrides = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

      return this.dataRequestWithClient(client, _http_client_factory.HttpVerbs.POST, path, data, overrides);
    }
  }, {
    key: 'putWithClient',
    value: function putWithClient(client, path, data) {
      var overrides = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

      return this.dataRequestWithClient(client, _http_client_factory.HttpVerbs.PUT, path, data, overrides);
    }
  }, {
    key: 'simpleRequestWithClient',
    value: function simpleRequestWithClient(client, method, path) {
      var overrides = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

      return this.handleFetch(client.fetch(path, {
        method: method
      }), overrides);
    }
  }, {
    key: 'dataRequestWithClient',
    value: function dataRequestWithClient(client, method, path, data) {
      var overrides = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};

      return this.handleFetch(client.fetch(path, {
        method: method,
        body: (0, _aureliaFetchClient.json)(data)
      }), overrides);
    }
  }, {
    key: 'handleFetch',
    value: function handleFetch(promise) {
      var _this = this;

      var overrides = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return promise.then(function (response) {
        return _this.sensor.process(response, overrides);
      }).then(function (data) {
        return _this.transformer.transform(data);
      }).catch(function (error) {
        return _this.sensor.processError(error);
      });
    }
  }]);

  return HttpGateway;
}();